import {
  taboolaFeedClickEvent,
  taboolaFeedEmbedEvent,
  taboolaFeedViewabilityEvent,
} from '../../jsCore/organizedByType/actions/analyticsActions'
import { dispatch } from '../../jsCore/application/appStore'

let isReportEmbed = false

export function taboolaFeedEventsReporter() {
  window._taboola = window._taboola || []
  window._taboola.push({
    listenTo: 'click',
    handler: function(e) {
      if (undefined !== e && e !== null) {
        let cardType = e.detail.type
        if (cardType === 'sponsored') {
          cardType = 'paid content click'
        } else {
          cardType = 'article click'
        }
        let slot = e.detail.slot
        if (undefined !== e.detail.placement) {
          let placement = e.detail.placement
          let card = placement !== undefined ? placement.slice(-2) : ''
          let client = 'bottom'
          if (placement.includes('Desktop Sidebar')) {
            client = 'right'
          }
          dispatch(taboolaFeedClickEvent(cardType, slot, card, client))
        }
      }
    },
  })

  window._taboola.push({
    listenTo: 'render',
    handler: function(e) {
      if (!isReportEmbed && undefined !== e && e !== null) {
        isReportEmbed = true
        dispatch(taboolaFeedEmbedEvent())
      }
    },
  })

  window._taboola.push({
    listenTo: 'visible',
    handler: function(e) {
      if (undefined !== e && e !== null) {
        let cardType = 'sponsored'
        if (null !== e.detail.baseMode) {
          cardType = e.detail.baseMode.includes('organic') ? 'article recommendations' : 'sponsored'
        }
        let placement = e.detail.placement
        let card = placement !== undefined ? placement.slice(-2) : ''
        let client = 'bottom'
        if (placement.includes('Desktop Sidebar')) {
          client = 'right'
        }
        dispatch(taboolaFeedViewabilityEvent(cardType, card, client))
      }
    },
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/taboolaFeedEventsTracker/taboolaFeedEventsTracker.js